import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const LoggedOutHeaderOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoggedOutHeaderOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgName"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitOn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"MemberHeader"},{"kind":"EnumValue","value":"MemberBoards"}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberType"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"LoggedOutHeaderOrganization","document":LoggedOutHeaderOrganizationDocument}} as const;
export type LoggedOutHeaderOrganizationQueryVariables = Types.Exact<{
  orgName: Types.Scalars['ID'];
}>;


export type LoggedOutHeaderOrganizationQuery = (
  { __typename: 'Query' }
  & { organization?: Types.Maybe<(
    { __typename: 'Organization' }
    & Pick<Types.Organization, 'id'>
    & { members: Array<(
      { __typename: 'Member' }
      & Pick<Types.Member, 'id' | 'memberType'>
    )> }
  )> }
);




/**
 * __useLoggedOutHeaderOrganizationQuery__
 *
 * To run a query within a React component, call `useLoggedOutHeaderOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoggedOutHeaderOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoggedOutHeaderOrganizationQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useLoggedOutHeaderOrganizationQuery(baseOptions: Apollo.QueryHookOptions<LoggedOutHeaderOrganizationQuery, LoggedOutHeaderOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoggedOutHeaderOrganizationQuery, LoggedOutHeaderOrganizationQueryVariables>(LoggedOutHeaderOrganizationDocument, options);
      }
export function useLoggedOutHeaderOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoggedOutHeaderOrganizationQuery, LoggedOutHeaderOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoggedOutHeaderOrganizationQuery, LoggedOutHeaderOrganizationQueryVariables>(LoggedOutHeaderOrganizationDocument, options);
        }
export type LoggedOutHeaderOrganizationQueryHookResult = ReturnType<typeof useLoggedOutHeaderOrganizationQuery>;
export type LoggedOutHeaderOrganizationLazyQueryHookResult = ReturnType<typeof useLoggedOutHeaderOrganizationLazyQuery>;
export type LoggedOutHeaderOrganizationQueryResult = Apollo.QueryResult<LoggedOutHeaderOrganizationQuery, LoggedOutHeaderOrganizationQueryVariables>;